import {
  GET_DOWNLOAD_PENGURUS_PUSAT,
  GET_DOWNLOAD_PENGURUS_PUSAT_SUCCESS,
  GET_DOWNLOAD_PENGURUS_PUSAT_FAIL,
  GET_DOWNLOAD_PENGURUS_PROVINSI,
  GET_DOWNLOAD_PENGURUS_PROVINSI_SUCCESS,
  GET_DOWNLOAD_PENGURUS_PROVINSI_FAIL,
  GET_DOWNLOAD_PENGURUS_KABKOT,
  GET_DOWNLOAD_PENGURUS_KABKOT_SUCCESS,
  GET_DOWNLOAD_PENGURUS_KABKOT_FAIL,
  GET_DOWNLOAD_PENGURUS_KECAMATAN,
  GET_DOWNLOAD_PENGURUS_KECAMATAN_SUCCESS,
  GET_DOWNLOAD_PENGURUS_KECAMATAN_FAIL,

  GET_DOWNLOAD_REKAP_PENGURUS_PUSAT,
  GET_DOWNLOAD_REKAP_PENGURUS_PUSAT_SUCCESS,
  GET_DOWNLOAD_REKAP_PENGURUS_PUSAT_FAIL,
  GET_DOWNLOAD_REKAP_PENGURUS_PROVINSI,
  GET_DOWNLOAD_REKAP_PENGURUS_PROVINSI_SUCCESS,
  GET_DOWNLOAD_REKAP_PENGURUS_PROVINSI_FAIL,
  GET_DOWNLOAD_REKAP_PENGURUS_KABKOT,
  GET_DOWNLOAD_REKAP_PENGURUS_KABKOT_SUCCESS,
  GET_DOWNLOAD_REKAP_PENGURUS_KABKOT_FAIL,

  GET_DOWNLOAD_REKAP_ANGGOTA,
  GET_DOWNLOAD_REKAP_ANGGOTA_SUCCESS,
  GET_DOWNLOAD_REKAP_ANGGOTA_FAIL,
  GET_DOWNLOAD_DAFTAR_ANGGOTA,
  GET_DOWNLOAD_DAFTAR_ANGGOTA_SUCCESS,
  GET_DOWNLOAD_DAFTAR_ANGGOTA_FAIL,
  } from "./actionTypes";
  
  const initialState = {
    downloadPengurusPusat: {
      loading: false,
      error: false,
      data: null,
    },
    downloadPengurusProvinsi: {
      loading: false,
      error: false,
      data: null,
    },
    downloadPengurusKabkot: {
      loading: false,
      error: false,
      data: null,
    },
    downloadPengurusKecamatan: {
      loading: false,
      error: false,
      data: null,
    },
    downloadRekapPengurusPusat: {
      loading: false,
      error: false,
      data: null,
    },
    downloadRekapPengurusProvinsi: {
      loading: false,
      error: false,
      data: null,
    },
		downloadRekapPengurusKabkot: {
      loading: false,
      error: false,
      data: null,
    },
    downloadRekapAnggota: {
      loading: false,
      error: false,
      data: null,
    },
    downloadDaftarAnggota: {
      loading: false,
      error: false,
      data: null,
    },
  };
  
  const reducer = (state = initialState, action) => {
    switch (action.type) {
      // get table exco pusat
      case GET_DOWNLOAD_PENGURUS_PUSAT:
        return {
          ...state,
          downloadPengurusPusat: {
            ...state.downloadPengurusPusat,
            loading: true,
            error: false,
          },
        };
      case GET_DOWNLOAD_PENGURUS_PUSAT_SUCCESS:
        return {
          ...state,
          downloadPengurusPusat: {
            ...state.downloadPengurusPusat,
            loading: false,
            error: false,
            data: action.payload,
          },
        };
      case GET_DOWNLOAD_PENGURUS_PUSAT_FAIL:
        return {
          ...state,
          downloadPengurusPusat: {
            ...state.downloadPengurusPusat,
            loading: false,
            error: action.payload,
          },
      };
      case GET_DOWNLOAD_PENGURUS_PROVINSI:
        return {
          ...state,
          downloadPengurusProvinsi: {
            ...state.downloadPengurusProvinsi,
            loading: true,
            error: false,
          },
        };
      case GET_DOWNLOAD_PENGURUS_PROVINSI_SUCCESS:
        return {
          ...state,
          downloadPengurusProvinsi: {
            ...state.downloadPengurusProvinsi,
            loading: false,
            error: false,
            data: action.payload,
          },
        };
      case GET_DOWNLOAD_PENGURUS_PROVINSI_FAIL:
        return {
          ...state,
          downloadPengurusProvinsi: {
            ...state.downloadPengurusProvinsi,
            loading: false,
            error: action.payload,
          },
      };
      case GET_DOWNLOAD_PENGURUS_KABKOT:
        return {
          ...state,
          downloadPengurusKabkot: {
            ...state.downloadPengurusKabkot,
            loading: true,
            error: false,
          },
        };
      case GET_DOWNLOAD_PENGURUS_KABKOT_SUCCESS:
        return {
          ...state,
          downloadPengurusKabkot: {
            ...state.downloadPengurusKabkot,
            loading: false,
            error: false,
            data: action.payload,
          },
        };
      case GET_DOWNLOAD_PENGURUS_KABKOT_FAIL:
        return {
          ...state,
          downloadPengurusKabkot: {
            ...state.downloadPengurusKabkot,
            loading: false,
            error: action.payload,
          },
      };
      case GET_DOWNLOAD_PENGURUS_KECAMATAN:
        return {
          ...state,
          downloadPengurusKecamatan: {
            ...state.downloadPengurusKecamatan,
            loading: true,
            error: false,
          },
        };
      case GET_DOWNLOAD_PENGURUS_KECAMATAN_SUCCESS:
        return {
          ...state,
          downloadPengurusKecamatan: {
            ...state.downloadPengurusKecamatan,
            loading: false,
            error: false,
            data: action.payload,
          },
        };
      case GET_DOWNLOAD_PENGURUS_KECAMATAN_FAIL:
        return {
          ...state,
          downloadPengurusKecamatan: {
            ...state.downloadPengurusKecamatan,
            loading: false,
            error: action.payload,
          },
      };
      case GET_DOWNLOAD_REKAP_PENGURUS_PUSAT:
        return {
          ...state,
          downloadRekapPengurusPusat: {
            ...state.downloadRekapPengurusPusat,
            loading: true,
            error: false,
          },
        };
      case GET_DOWNLOAD_REKAP_PENGURUS_PUSAT_SUCCESS:
        return {
          ...state,
          downloadRekapPengurusPusat: {
            ...state.downloadRekapPengurusPusat,
            loading: false,
            error: false,
            data: action.payload,
          },
        };
      case GET_DOWNLOAD_REKAP_PENGURUS_PUSAT_FAIL:
        return {
          ...state,
          downloadRekapPengurusPusat: {
            ...state.downloadRekapPengurusPusat,
            loading: false,
            error: action.payload,
          },
      };
      case GET_DOWNLOAD_REKAP_PENGURUS_PROVINSI:
        return {
          ...state,
          downloadRekapPengurusProvinsi: {
            ...state.downloadRekapPengurusProvinsi,
            loading: true,
            error: false,
          },
        };
      case GET_DOWNLOAD_REKAP_PENGURUS_PROVINSI_SUCCESS:
        return {
          ...state,
          downloadRekapPengurusProvinsi: {
            ...state.downloadRekapPengurusProvinsi,
            loading: false,
            error: false,
            data: action.payload,
          },
        };
      case GET_DOWNLOAD_REKAP_PENGURUS_PROVINSI_FAIL:
        return {
          ...state,
          downloadRekapPengurusProvinsi: {
            ...state.downloadRekapPengurusProvinsi,
            loading: false,
            error: action.payload,
          },
      };
			case GET_DOWNLOAD_REKAP_PENGURUS_KABKOT:
        return {
          ...state,
          downloadRekapPengurusKabkot: {
            ...state.downloadRekapPengurusKabkot,
            loading: true,
            error: false,
          },
        };
      case GET_DOWNLOAD_REKAP_PENGURUS_KABKOT_SUCCESS:
        return {
          ...state,
          downloadRekapPengurusKabkot: {
            ...state.downloadRekapPengurusKabkot,
            loading: false,
            error: false,
            data: action.payload,
          },
        };
      case GET_DOWNLOAD_REKAP_PENGURUS_KABKOT_FAIL:
        return {
          ...state,
          downloadRekapPengurusKabkot: {
            ...state.downloadRekapPengurusKabkot,
            loading: false,
            error: action.payload,
          },
      };
      case GET_DOWNLOAD_REKAP_ANGGOTA:
        return {
          ...state,
          downloadRekapAnggota: {
            ...state.downloadRekapAnggota,
            loading: true,
            error: false,
          },
        };
      case GET_DOWNLOAD_REKAP_ANGGOTA_SUCCESS:
        return {
          ...state,
          downloadRekapAnggota: {
            ...state.downloadRekapAnggota,
            loading: false,
            error: false,
            data: action.payload,
          },
        };
      case GET_DOWNLOAD_REKAP_ANGGOTA_FAIL:
        return {
          ...state,
          downloadRekapAnggota: {
            ...state.downloadRekapAnggota,
            loading: false,
            error: action.payload,
          },
      };
      case GET_DOWNLOAD_DAFTAR_ANGGOTA:
        return {
          ...state,
          downloadDaftarAnggota: {
            ...state.downloadDaftarAnggota,
            loading: true,
            error: false,
          },
        };
      case GET_DOWNLOAD_DAFTAR_ANGGOTA_SUCCESS:
        return {
          ...state,
          downloadDaftarAnggota: {
            ...state.downloadDaftarAnggota,
            loading: false,
            error: false,
            data: action.payload,
          },
        };
      case GET_DOWNLOAD_DAFTAR_ANGGOTA_FAIL:
        return {
          ...state,
          downloadDaftarAnggota: {
            ...state.downloadDaftarAnggota,
            loading: false,
            error: action.payload,
          },
      };
      
			
      default:
        return state;
    }
  };
  
  export default reducer;
  